module.exports = __webpack_public_path__ + "img/2x.d5eafd1.jpg";